<template>
  <MainLayout v-if="$route.meta.layout == 'main'" />
  <AuthLayout v-if="$route.meta.layout == 'auth'" />
  <QR v-if="$route.meta.layout == 'qr'" />
</template>

<script>
import MainLayout from "./components/Layouts/MainLayout.vue";
import AuthLayout from "./components/Layouts/AuthLayout.vue";
import QR from "./components/Layouts/QR.vue";

export default {
  name: "App",
  components: {
    MainLayout,
    AuthLayout,
    QR,
  },
  data: () => ({
    isLoggedIn: false,
    user: {},
  }),
  mounted() {
    this.user = this.$store.state.user;
    this.checkAuth();
  },
  methods: {
    checkAuth: function () {
      if (localStorage.getItem("user") && localStorage.getItem("token")) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    },
  },
};
</script>
